// extracted by mini-css-extract-plugin
export default {"content":"style_content__V+v8p","checkbox":"style_checkbox__5YbeH"};